import { Link } from "@tanstack/react-router";
import { AnkhMark } from "./AnkhMark";
import { FeedbackDialog } from "./FeedbackDialog";
import { NewsletterForm } from "./NewsletterForm";
import { NAV_LINKS, STREAMING_LINKS } from "@/lib/content";

export function Footer() {
  return (
    <footer className="mt-24 border-t hairline bg-charcoal">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-4">
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <AnkhMark size={40} />
            <div>
              <p className="font-serif text-lg text-gold-luminous">BUDDHA KA</p>
              <p className="text-xs uppercase tracking-[0.25em] text-muted-foreground">KAfrequency</p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            Music, books, and inner technology from Buddha KA — founder of KAfrequency.
          </p>
        </div>

        <nav aria-label="Sitemap" className="grid grid-cols-2 gap-2 text-sm lg:col-span-2">
          {NAV_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-foreground/80 hover:text-gold">
              {l.label}
            </Link>
          ))}
          <Link to="/library" className="text-foreground/80 hover:text-gold">Library</Link>
          <Link to="/playlists" className="text-foreground/80 hover:text-gold">Playlists</Link>
          <Link to="/membership" className="text-foreground/80 hover:text-gold">Membership</Link>
          <Link to="/press" className="text-foreground/80 hover:text-gold">Press</Link>
          <Link to="/news" className="text-foreground/80 hover:text-gold">News</Link>
          <Link to="/topics" className="text-foreground/80 hover:text-gold">Topics</Link>
          <Link to="/glossary" className="text-foreground/80 hover:text-gold">Glossary</Link>
          <Link to="/artist/buddha-ka" className="text-foreground/80 hover:text-gold">Official Buddha KA Artist Page</Link>
          <Link to="/music/discography" className="text-foreground/80 hover:text-gold">Discography</Link>
          <Link to="/books/bibliography" className="text-foreground/80 hover:text-gold">Bibliography</Link>
          <Link to="/media" className="text-foreground/80 hover:text-gold">Media</Link>
          <Link to="/contact" className="text-foreground/80 hover:text-gold">Contact</Link>
        </nav>


        <div className="space-y-3">
          <p className="text-xs uppercase tracking-[0.25em] text-gold">Receive the Transmission</p>
          <NewsletterForm source="footer" />
          <div className="flex flex-wrap gap-2 pt-2">
            {(Object.entries(STREAMING_LINKS) as Array<[string, string]>).map(([key, url]) => (
              <a
                key={key}
                href={url}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-gold/40 bg-gold/10 px-3 py-1 text-[11px] text-gold-luminous hover:bg-gold hover:text-obsidian"
              >
                {key} →
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t hairline">
        <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-2 px-4 py-6 text-xs text-muted-foreground sm:grid-cols-[1fr_auto] sm:px-6">
          <p>
            © {new Date().getFullYear()} Buddha KA · KAfrequency. Built from inner structure. <span className="text-gold">Ase&rsquo;.</span>
          </p>
          <nav aria-label="Legal" className="flex flex-wrap items-center gap-4">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/refund">Refund</Link>
            <Link to="/shipping">Shipping</Link>
           <Link to="/cookies">Cookies</Link>
           <Link to="/accessibility">Accessibility</Link>
           <FeedbackDialog />
          </nav>
        </div>
      </div>
    </footer>
  );
}
